/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UsersFindAllResponse } from './UsersFindAllResponse';
import {
    UsersFindAllResponseFromJSON,
    UsersFindAllResponseFromJSONTyped,
    UsersFindAllResponseToJSON,
} from './UsersFindAllResponse';

/**
 * 
 * @export
 * @interface FindAllUsersV2200Response
 */
export interface FindAllUsersV2200Response {
    /**
     * 
     * @type {UsersFindAllResponse}
     * @memberof FindAllUsersV2200Response
     */
    data?: UsersFindAllResponse;
}

/**
 * Check if a given object implements the FindAllUsersV2200Response interface.
 */
export function instanceOfFindAllUsersV2200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllUsersV2200ResponseFromJSON(json: any): FindAllUsersV2200Response {
    return FindAllUsersV2200ResponseFromJSONTyped(json, false);
}

export function FindAllUsersV2200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllUsersV2200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : UsersFindAllResponseFromJSON(json['data']),
    };
}

export function FindAllUsersV2200ResponseToJSON(value?: FindAllUsersV2200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': UsersFindAllResponseToJSON(value.data),
    };
}

